import styled from 'styled-components';

export const QualityValue = styled.div`
  font-weight: 500;
`;
